import AuthService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("user"));
const initialState = user ? {
	status: {
		loggedIn: true
	},
	user
} : {
	status: {
		loggedIn: false,
		resetRequested: false,
		passwordChanged: false,
	},
	user: null
};

export const auth = {
	namespaced: true,
	state: initialState,
	actions: {
		login({
			commit
		}, user) {
			return AuthService.login(user).then(
				(user) => {
					commit("LOGIN_SUCCESS", user);
					return Promise.resolve(user);
				},
				(error) => {
					commit("LOGIN_FAILURE");
					return Promise.reject(error);
				}
			);
		},
		logout({
			commit
		}) {
			AuthService.logout();
			commit("LOGOUT");
		},
		register({
			commit
		}, user) {
			return AuthService.register(user).then(
				(response) => {
					commit("REGISTER_SUCCESS");
					return Promise.resolve(response.data);
				},
				(error) => {
					commit("REGISTER_FAILURE");
					return Promise.reject(error);
				}
			);
		},
		requestReset({
			commit
		}, user) {
			return AuthService.requestReset(user).then(
				(response) => {
					commit("RESET_REQUEST_SUCCESS");
					return Promise.resolve(response.data);
				},
				(error) => {
					commit("RESET_REQUEST_FAILURE");
					return Promise.reject(error);
				}
			);
		},
		changePassword({
			commit
		}, user) {
			return AuthService.changePassword(user).then(
				(response) => {
					commit("CHANGE_PASSWORD_SUCCESS");
					return Promise.resolve(response.data);
				},
				(error) => {
					commit("CHANGE_PASSWORD_FAILURE");
					return Promise.reject(error);
				}
			);
		}
	},
	mutations: {
		LOGIN_SUCCESS(state, user) {
			state.status.loggedIn = true;
			state.user = user;
		},
		LOGIN_FAILURE(state) {
			state.status.loggedIn = false;
			state.user = null;
		},
		LOGOUT(state) {
			state.status.loggedIn = false;
			state.user = null;
		},
		UPDATE_USER(state, user) {
			state.user = user;
			state.profile = user.profile;
		},
		REGISTER_SUCCESS(state) {
			state.status.loggedIn = false;
		},
		REGISTER_FAILURE(state) {
			state.status.loggedIn = false;
		},
		RESET_REQUEST_SUCCESS(state) {
			state.status.resetRequested = true;
		},
		RESET_REQUEST_FAILURE(state) {
			state.status.resetRequested = false;
		},
		CHANGE_PASSWORD_SUCCESS(state) {
			state.status.passwordChanged = true;
		},
		CHANGE_PASSWORD_FAILURE(state) {
			state.status.passwordChanged = false;
		},
	},
};
